import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './components/util/AuthContext';
import Layout from './components/layout/Layout';
import LoginPage from './pages/LoginPage';
import WorkPage from './pages/WorkPage';
import MaterialPage from './pages/MaterialPage';
import EstimatePage from './pages/EstimatePage';
import OutsourcingPage from './pages/OutsourcingPage';
import ProtectedRoute from './components/util/ProtectedRoute';
import TestPage from './pages/test';


function App() {
  return(
    <AuthProvider>
      <Router>
          <Routes>
            <Route path = "/login" element = {<LoginPage/>}/>
            <Route path = "/test" element = {<TestPage/>}/>
            <Route element = {<Layout/>}>
              <Route 
                path = "/" 
                element = {
                  <ProtectedRoute>
                    <WorkPage/>
                  </ProtectedRoute>
                }
              />
              <Route 
                path = "/construction" 
                element = {
                  <ProtectedRoute>
                    <WorkPage/>
                  </ProtectedRoute>
                }
              />
              <Route 
                path = "/estimate" 
                element = {
                  <ProtectedRoute>
                    <EstimatePage/>
                  </ProtectedRoute>
                }
              />
              <Route 
                path = "/material" 
                element = {
                  <ProtectedRoute>
                    <MaterialPage/>
                  </ProtectedRoute>
                }
              />
              <Route 
                path = "/outsourcing"
                element = {
                  <ProtectedRoute>
                    <OutsourcingPage/>
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
